import type { LogProviderInterface } from 'utils/logger/logProviderFactory';

/**
 * Log generic messages here
 * @param {*} message
 */
const logMessage = (message: string) => {
    console.log(message);
};

/**
 * Log warning messages here
 * @param {*} message
 */
const logWarning = (message: string) => {
    console.warn(message);
};

const logError = (error: Error | string | unknown) => {
    console.error(error);
};

export default {
    logMessage,
    logError,
    logWarning,
} as LogProviderInterface;
